export default "__VITE_ASSET__BiHIf$NT__"